<div class="activity">
  <div class="table-actions">
    @if (featureFlagsService.isFeatureEnabled(featureFlagTypes.UnifiedPipeline)) {
      <!-- When UnifiedPipeline FF is ON, use unified pageFilters for both modes -->
      <app-ai-activity-filters class="full-width" [pageFilters]="pageFilters"></app-ai-activity-filters>
    } @else {
      <!-- Legacy behavior: separate filters for each mode -->
      @if (selectedToggle() === 'option1') {
        <app-ai-activity-filters class="full-width" [pageFilters]="pageFilters"></app-ai-activity-filters>
      } @else {
        <app-ai-inline-activity-filters
          class="full-width"
          [pageFilters]="aiInlineActivityPageFilters"
        ></app-ai-inline-activity-filters>
      }
    }
  </div>
  <div class="table-header">
    @if (totalItems > -1) {
      <div class="resources-amount">
        {{ 'common.found' | labelsProvider }} {{ totalItems | number }} {{ 'steps' }}
        @if (totalThreads !== undefined) {
          , {{ totalThreads | number }} {{ 'threads' }}
        }
      </div>
    }

    @if (featureFlagsService.isFeatureEnabled(featureFlagTypes.InlinePrevention)) {
      <div class="toggle-container">
        <app-option-toggle
          [selectedOption]="selectedToggle()"
          [option1Text]="option1Text()"
          [option2Text]="option2Text()"
          [option1Icon]="option1Icon()"
          [option2Icon]="option2Icon()"
          (optionChange)="onToggleChange($event)"
        >
        </app-option-toggle>
      </div>
    }
  </div>
  <div class="table">
    @if (featureFlagsService.isFeatureEnabled(featureFlagTypes.UnifiedPipeline)) {
      <!-- When UnifiedPipeline FF is ON, use unified vertical filters for both modes -->
      <app-ai-activity-vertical-filters
        [ngClass]="{ 'filters-all': isFiltersMenuOpen }"
        (optionOnSelection)="tablesFiltersChange($event)"
        [pageFilters]="pageFilters"
        [isFiltersMenuOpen]="isFiltersMenuOpen"
        (filtersOnMenuStateChange)="filtersOnMenuStateChange($event)"
      >
      </app-ai-activity-vertical-filters>
    } @else {
      <!-- Legacy behavior: separate vertical filters for each mode -->
      @if (selectedToggle() === 'option1') {
        <app-ai-activity-vertical-filters
          [ngClass]="{ 'filters-all': isFiltersMenuOpen }"
          (optionOnSelection)="tablesFiltersChange($event)"
          [pageFilters]="pageFilters"
          [isFiltersMenuOpen]="isFiltersMenuOpen"
          (filtersOnMenuStateChange)="filtersOnMenuStateChange($event)"
        >
        </app-ai-activity-vertical-filters>
      } @else {
        <app-ai-inline-activity-vertical-filters
          [ngClass]="{ 'filters-all': isFiltersMenuOpen }"
          (optionOnSelection)="tablesFiltersChange($event)"
          [pageFilters]="aiInlineActivityPageFilters"
          [isFiltersMenuOpen]="isFiltersMenuOpen"
          (filtersOnMenuStateChange)="filtersOnMenuStateChange($event)"
        >
        </app-ai-inline-activity-vertical-filters>
      }
    }
    <app-prime-table
      #table
      [ngClass]="!isFiltersMenuOpen ? 'table-collapsed-menu' : 'table-component'"
      queryParamProperty="agentStep"
      [data$]="currentTableData$"
      [rowsPerPage]="defaultPageSize"
      [columns]="columns()"
      [isLoading]="(isLoading$ | async) === true"
      [withCheckboxSelection]="false"
      [sortedColumn$]="
        featureFlagsService.isFeatureEnabled(featureFlagTypes.UnifiedPipeline)
          ? pageFilters.sortedColumn$
          : selectedToggle() === 'option1'
            ? pageFilters.sortedColumn$
            : aiInlineActivityPageFilters.sortedColumn$
      "
      [pageInfo]="pageInfo$.value"
      tableNotFoundText="You don't have any resources"
      (rowUnselected)="rowUnselected()"
      (rowSelected)="rowSelected($event)"
      tableNotFoundIcon="assets/images/common/no-results-found.svg"
      (pageOnChange)="onPagination($event)"
    />
  </div>
</div>
